import { render, staticRenderFns } from "./BodyPresetGrid.vue?vue&type=template&id=c072a98a&scoped=true"
import script from "./BodyPresetGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./BodyPresetGrid.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BodyPresetGrid.vue?vue&type=style&index=0&id=c072a98a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c072a98a",
  null
  
)

export default component.exports